import UpgradeButton from './UpgradeButton.vue';

export default UpgradeButton;
